import api from "../../Hooks/axiosApi";

export const createBuilderService = (data: any) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  return api.post('/api/Crm/AddBuilder', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


export const updateBuilderService = ({ builderID, data }: { builderID: any; data: any }) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  return api.put(`/api/Crm/UpdateBuilder/${builderID}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteBuilderService = (id: any) => {
  return api.delete(`/api/Crm/DeleteBuilder/${id}`);
};

export const getAllBuildersService = () => {
  return api.get('api/Crm/GetAllBuilders');
};

export const getBuilderByIdService = (id: any) => {
  return api.get(`/api/Crm/GetBuilderById/${id}`);
};

export const getSupplierCommentsService = (supplierId: any) => {
  return api.get(`/api/Crm/GetsupplierComments/${supplierId}`);
};

export const updateBuilderIsActiveService = ({ supplierId, isActive }: { supplierId: number; isActive: boolean }) => {
  return api.put(`/api/Crm/update-isactive?supplierId=${supplierId}&isActive=${isActive}`);
};
